import React, {useState, useEffect} from 'react';
import {
  ScrollView,
  View,
  Text,
  TouchableOpacity,
  StatusBar,
  SafeAreaView,
  ActivityIndicator,
} from 'react-native';
import Share from 'react-native-share';
import LinearGradient from 'react-native-linear-gradient';
import styles from './styles';
import Bold from '../../../typography/BoldText';
import Medium from '../../../typography/MediumText';
import ApiService from '../../../util/apiService';
import CalendarPicker from '../../../components/CalendarPicker';
import Icon from 'react-native-vector-icons/Ionicons';

const DailyDevotionScreen = ({navigation, route}) => {
  const [currentDate, setCurrentDate] = useState('');
  const [dailyDevotion, setDailyDevotion] = useState(null);
  const [calendarVisible, setCalendarVisible] = useState(false);

  useEffect(() => {
    loadDevotion();
  }, [route.params?.selectedDate]);

  const loadDevotion = async () => {
    try {
      const passedDate = route.params?.selectedDate;
      if (passedDate) {
        console.log('🔄 Loading devotion for date:', passedDate);
        const devotion = await ApiService.getDevotionByDate(passedDate);
        if (devotion) {
          setDailyDevotion(devotion);
          const date = new Date(passedDate);
          setCurrentDate(date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));
        }
      } else {
        const today = new Date();
        setCurrentDate(today.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));
        console.log('🔄 Loading today\'s devotion from API...');
        const todaysDevotion = await ApiService.getTodaysDevotion();
        if (todaysDevotion && todaysDevotion.today) {
          setDailyDevotion(todaysDevotion.today);
        } else {
          console.log('⚠️ No devotion found for today');
        }
      }
    } catch (error) {
      console.error('❌ Error loading devotion from API:', error);
    }
  };

  const handleShare = async () => {
    if (!dailyDevotion) return;
    const shareMessage = `✨ ${dailyDevotion.title} ✨\n\n${dailyDevotion.text}\n\n📅 ${currentDate}\n\n🙏 Shared from Praise Devotion App`;
    try {
      await Share.open({ title: `Daily Devotion - ${dailyDevotion.title}`, message: shareMessage, type: 'text/plain' });
    } catch {}
  };

  if (!dailyDevotion) {
    return (
      <SafeAreaView style={styles.container}>
        <StatusBar barStyle="light-content" backgroundColor="#6C4D2A" />
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color="#D0B277" />
          <Bold style={styles.loadingText}>Loading devotion...</Bold>
        </View>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor="#6C4D2A" />
      <ScrollView contentContainerStyle={styles.scrollContainer}>
        <View style={styles.header}>
          <View style={styles.headerCenter}>
            <Bold style={styles.dateText}>{currentDate}</Bold>
            <Bold style={styles.headerTitle}>Daily Devotion</Bold>
          </View>
        </View>
        <View style={styles.devotionCardContainer}>
          <LinearGradient
            colors={["#6C4D2A", "#B09569", "#D0B277"]}
            start={{x: 0, y: 0}}
            end={{x: 1, y: 1}}
            style={styles.devotionBackgroundGradient}
          >
            <View style={styles.darkOverlay} />
            <View style={styles.cornerDecoration}><Text style={styles.cornerText}>✝</Text></View>
            <View style={styles.cornerDecoration2}><Text style={styles.cornerText}>✝</Text></View>
            <View style={styles.devotionContent}>
              <Bold style={styles.devotionCardTitle}>{dailyDevotion.title}</Bold>
              <Text style={styles.devotionCardText}>{dailyDevotion.text}</Text>
              <View style={styles.devotionFooter}>
                <Medium style={styles.devotionDate}>{currentDate}</Medium>
              </View>
            </View>
            <TouchableOpacity style={styles.floatingShareButton} onPress={handleShare} activeOpacity={0.9}>
              <LinearGradient colors={["#FFD700", "#FFA500", "#FF8C00"]} start={{x: 0, y: 0}} end={{x: 1, y: 1}} style={styles.floatingShareGradient}>
                <Icon name="share-social" size={20} color="#FFFFFF" />
                <Bold style={styles.floatingShareText}>Share</Bold>
              </LinearGradient>
            </TouchableOpacity>
          </LinearGradient>
        </View>
        <View style={styles.buttonContainer}>
          <TouchableOpacity style={styles.authorButton} onPress={() => navigation.navigate('AuthorBio', { authorId: dailyDevotion?.author_id || 1, authorName: dailyDevotion?.author_full_name || dailyDevotion?.author_name || 'Unknown Author' })} activeOpacity={0.8}>
            <LinearGradient colors={["#B09569", "#D0B277", "#B09569"]} start={{x: 0, y: 0}} end={{x: 1, y: 0}} style={styles.authorButtonGradient}>
              <Icon name="person-circle-outline" size={20} color="#FFFFFF" />
              <Bold style={styles.authorButtonText}>About the Author</Bold>
              <Icon name="chevron-forward" size={18} color="#FFFFFF" />
            </LinearGradient>
          </TouchableOpacity>
        </View>
      </ScrollView>
      <CalendarPicker visible={calendarVisible} onClose={() => setCalendarVisible(false)} onDateSelect={async (date) => {
        console.log('🔄 Loading devotion for selected date:', date);
        const devotion = await ApiService.getDevotionByDate(date);
        if (devotion) {
          setDailyDevotion(devotion);
          const selectedDateObj = new Date(date);
          setCurrentDate(selectedDateObj.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }));
        }
      }} />
    </SafeAreaView>
  );
};

export default DailyDevotionScreen;